// Lightweight schema definition to keep InstantDB happy in both mock and real modes.
// This prevents IndexedDB "object store not found" issues during auth and data fetch.
const APP_ID = process.env.NEXT_PUBLIC_INSTANTDB_APP_ID || ""
const IS_MOCK_MODE = !APP_ID || APP_ID === "placeholder_app_id" || APP_ID.trim() === ""

export const schema = {
  entities: {
    users: {
      id: { type: "uuid", unique: true },
      email: { type: "string", index: true },
      name: { type: "string" },
      role: { type: "string", index: true },
      tier: { type: "string" },
      avatar: { type: "string" },
      phone: { type: "string" },
      source: { type: "string" },
      instantUserId: { type: "string" },
      createdAt: { type: "number" },
      signupDate: { type: "number" },
      lastLogin: { type: "number" },
    },
    price_alerts: {
      id: { type: "string", unique: true },
      userId: { type: "string", index: true },
      symbol: { type: "string" },
      market: { type: "string" },
      targetPrice: { type: "number" },
      direction: { type: "string" },
      customMessage: { type: "string" },
      imageUrl: { type: "string" },
      isActive: { type: "boolean" },
      triggered: { type: "boolean" },
      triggeredAt: { type: "number" },
      currentPrice: { type: "number" },
      createdAt: { type: "number" },
      updatedAt: { type: "number" },
      // New fields for teacher-to-student broadcasting
      isGlobal: { type: "boolean", index: true },
      createdByRole: { type: "string" },
    },
    notifications: {
      id: { type: "string", unique: true },
      userId: { type: "string", index: true },
      type: { type: "string" },
      title: { type: "string" },
      body: { type: "string" },
      data: { type: "object" },
      createdAt: { type: "number" },
      read: { type: "boolean" },
    },
    crypto_alert_state: {
      id: { type: "string", unique: true }, // e.g. symbol
      symbol: { type: "string", index: true },
      lastCheckpoint: { type: "number" }, // 20, 50, 100
      lastPrice: { type: "string" },
      lastUpdated: { type: "number" },
    },
    notification_preferences: {
      id: { type: "string", unique: true }, // same as userId
      userId: { type: "string", index: true },
      receiveAlerts: { type: "boolean" },
      emailEnabled: { type: "boolean" },
      smsEnabled: { type: "boolean" },
      phone: { type: "string" },
      minThreshold: { type: "number" }, // e.g. 20
      updatedAt: { type: "number" },
    },
    notification_logs: {
      id: { type: "string", unique: true },
      userId: { type: "string", index: true },
      symbol: { type: "string", index: true },
      checkpoint: { type: "number" },
      price: { type: "string" },
      sentVia: { type: "string" }, // email | sms
      sentAt: { type: "number" },
      status: { type: "string" }, // sent | failed
      error: { type: "string" },
    },
  },
  links: {},
  rooms: {},
}

// Export for both mock and real modes
export type AppSchema = typeof schema
export default schema
